document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".accordion_image-layout").forEach((layout) => {
		const items = [...layout.querySelectorAll(".accordion-item")];

		const setOpen = (item, open) => {
			item.classList.toggle("is-open", open);
			item.querySelector(".accordion-item-toggle").setAttribute("aria-expanded", open ? "true" : "false");
			item.querySelector(".accordion-item-panel").inert = !open;
		};

		items.forEach((item) => {
			item.querySelector(".accordion-item-toggle").addEventListener("click", () => {
				if (item.classList.contains("is-open")) return;
				items.forEach((other) => setOpen(other, other === item));
			});
		});
	});
});
